import { type FC } from "react";
import clsx, { type ClassValue } from "clsx";
import styles from "./Spinner.module.scss";

export interface SpinnerProps {
  isBlack?: boolean;
  isFullWidtHeight?: boolean;
  size: "sm" | "md" | "lg";
  showProgress?: boolean;
  progress?: number;
  className?: ClassValue;
}

const Spinner: FC<SpinnerProps> = ({
  isBlack = false,
  isFullWidtHeight = false,
  size = "md",
  showProgress = false,
  progress = 0,
  className,
}) => {
  const containerClasses = clsx(
    styles.spinnerContainerWrapper,
    {
      [styles.spinnerContainerWrapperBlack]: isBlack,
      [styles.isFullWidth]: isFullWidtHeight,
    },
    className
  );

  const loaderClasses = clsx(
    styles.loader,
    styles[size],
    isBlack && styles.black
  );
  const progressClasses = clsx(
    styles.progress,
    isBlack && styles.progressBlack
  );

  return (
    <div className={containerClasses}>
      <div className={styles.spinnerContent}>
        <span className={loaderClasses} />
        {showProgress && <span className={progressClasses}>{progress}%</span>}
      </div>
    </div>
  );
};

export default Spinner;
